<template>
  <div class="-mt-[100px] bg-neutral-100 pt-[100px]">
    <div class="px-4 py-10 lg:container lg:py-24">
      <div class="grid-default">
        <div class="col-span-6 lg:col-span-6 lg:col-end-7">
          <Heading
          v-if="data.title" :semantic="isSemantic" :level="level"
            class="mb-6 text-center text-5xl font-light text-blue lg:mb-0 lg:text-left lg:text-9xl"
            @completed="heroAnimated = true"
          >
            {{ data.title }}
          </Heading>
        </div>
        <div class="col-span-6 lg:col-span-6 lg:col-start-7">
          <div
            class="text-normal-600 mb-6 mt-10 text-left text-base font-light transition-opacity duration-300 lg:mb-0 lg:mt-0 lg:text-right lg:text-2xl"
            :class="heroAnimated ? 'opacity-100' : 'opacity-0'"
            v-html="data.subtitle"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { SectionShopHeroRecord } from '~/types/generated'
import { useAppStore } from '~/stores/AppStore'
const store = useAppStore()
const heroAnimated = ref(false)

const props = defineProps({
  data: {
    type: Object as PropType<SectionShopHeroRecord>,
    default: () => {}
  },
  index: {
    type: Number,
    required: true
  }
})

const { level, isSemantic } = useSectionRules(props.index, !!props.data.title)

onMounted(() => {
  store.setTheme('neutral')
})
</script>
